@let selection = selectionInput();
<span class="configurationInputWrapper" [class.invalidSelection]="isInvalidSelection()">
  <label class="guruLabel">{{ selection.Description || selection.Name }}</label>
  @if (isListSelection()) {
    <span>
      <select class="guruInput" [disabled]="isBusy()" [(ngModel)]="selection.Value" (ngModelChange)="selectionChanged()">
        @for (allowable of selection.Allowables; track allowable) {
          <option [value]="allowable.Value" class="allowableSelection" [class.invalidAllowable]="!allowable.IsValid"
          >{{ allowable.Description }}</option>
        }
      </select>
    </span>
  }
  @if (isBooleanSelection()) {
    <span>
      <span class="toggleContainer">
        <label class="toggleLabel">{{getFalseAllowableText()}}</label>
        <mat-slide-toggle color="primary" class="toggleButton" [checked]="isSelected()"
          [disabled]="isBusy()" (change)="booleanChanged()">
        </mat-slide-toggle>
        <label class="toggleLabel">{{getTrueAllowableText()}}</label>
      </span>
    </span>
  }
</span>
